import * as types from 'constants/actionTypes';
import * as Rx from 'rxjs';
const { Observable } = Rx;
const { of, ajax } = Observable;
import * as actions from 'actions/accountActions';
const apiUrls = require('constants/apiUrls');
import { wowCustomHeader } from '../utils/wowCustomHeadersUtils';
import { getAccessTokenFromState } from 'utils/userManager';

export const indirect = {
  call: (fn, ...args) => fn(...args)
};

export const api = {

  addMemo: (request, store) => {

    const state = store.getState();
    const accessToken = getAccessTokenFromState(state);

    const wowHeaders = wowCustomHeader(state);

    return ajax({
      url: apiUrls.ACCOUNT_MEMO_DETAIL_URL,
      method: 'POST',
      body: request,
      responseType: '',
      crossDomain: true,
      timeout: apiUrls.API_TIMEOUT,
      headers: {
        ...wowHeaders,
        'Content-Type': 'application/x-www-form-urlencoded',
        'authorization': 'Bearer ' + accessToken
      }
    });
  }
};

export const addMemoEpic = (action$, store, call = indirect.call) => action$
  .ofType(types.ADD_MEMO_STARTED)
  .mergeMap(action => call(api.addMemo, action.request, store).map(() => {
    return (actions.addMemoFinished(action.request, action.orderId, action.date));
  }).catch(error => of(actions.addMemoFailed(error, action.orderId))));



// WEBPACK FOOTER //
// ./src/epics/memoEpic.js